import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { AreaChart, Area } from 'recharts';
import '../../css/Admin.css';

const AdminStatsQuizStacked = ({ userStats, title = "Quiz Hebdomadaire" }) => {
  const [open, setOpen] = useState(true);

  if (!userStats || userStats.length === 0) return <p>Aucune donnée disponible.</p>;

  const chartData = Object.values(
    userStats.reduce((acc, s) => {
      const week = new Date(s.weekStart).toLocaleDateString();
      if (!acc[week]) acc[week] = { week, nbQuizStarted: 0, nbQuizCompleted: 0, totalDuration: 0, nbQuizCount: 0 };
      acc[week].nbQuizStarted += s.nbQuizStarted || 0;
      acc[week].nbQuizCompleted += s.nbQuizCompleted || 0;
      acc[week].totalDuration += (s.avgQuizDuration || 0) * (s.nbQuizCompleted || 0);
      acc[week].nbQuizCount += s.nbQuizCompleted || 0;
      return acc;
    }, {})
  ).map(d => ({
    week: d.week,
    completed: d.nbQuizCompleted,
    interrupt: (d.nbQuizStarted - d.nbQuizCompleted) > 0 ? d.nbQuizStarted - d.nbQuizCompleted : 0,
    avgDuration: d.nbQuizCount ? d.totalDuration / d.nbQuizCount / 60 : 0
  }));

  return (
    <div className="admin-quiz-stacked-container">
      {/* Titre du panel avec toggle */}
      <h2 className="quiz-chart-title" onClick={() => setOpen(!open)} style={{ cursor: 'pointer' }}>
        {title} {open ?  '▼' : '▲'}
      </h2>

      {/* Contenu toggle */}
      {open && (
        <div className="quiz-stacked-wrapper">

          {/* Stacked Bar Chart : completed / interrupt */}
          <div className="quiz-stacked-bar">
            <h3 className="quiz-chart-subtitle">Quiz complétés vs démarrés</h3>
            <ResponsiveContainer width="100%" height={200}>
              <BarChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                <XAxis dataKey="week" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="completed" stackId="a" fill="#22c55e" />
                <Bar dataKey="interrupt" stackId="a" fill="#ef4444" />
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* AreaChart pour durée moyenne */}
          <div className="quiz-avg-duration">
            <h3 className="quiz-chart-subtitle">Durée moyenne des quiz (min)</h3>
            <ResponsiveContainer width="100%" height={200}>
              <AreaChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                <XAxis dataKey="week" />
                <YAxis />
                <Tooltip formatter={(value) => `${value.toFixed(1)} min`} />
                <defs>
                  <linearGradient id="quizDurationGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8}/>
                    <stop offset="95%" stopColor="#3b82f6" stopOpacity={0}/>
                  </linearGradient>
                </defs>
                <Area type="monotone" dataKey="avgDuration" stroke="#3b82f6" fill="url(#quizDurationGradient)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>

        </div>
      )}
    </div>
  );
};

export default AdminStatsQuizStacked;
